export default __webpack_public_path__ + "static/media/ic_select_all_new.25bc5caf.svg";